import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20flowing%20lines%20and%20gentle%20golden%20light%20rays%20minimalist%20elegant%20style%20suitable%20for%20call%20to%20action%20section%20warm%20orange%20and%20amber%20tones&width=1920&height=600&seq=mv-cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-secondary-500/90 to-secondary-500/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
          无需下载，即刻开启观影之旅
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
          打开浏览器就能看，支持电脑端和手机端。海量影视资源，高清流畅播放，随时随地尽享精彩。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianshiju"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-semibold text-secondary-950 bg-accent-500 hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-fill text-xl"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-medium text-background-50 border border-background-50/30 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}